<template>
    <v-container fluid class="fill-height">
    <v-snackbar
      v-model="snackbarVerify"
      :vertical="vertical"
      color="red"
      :timeout="10000" top
    >
      {{ text }}
      <v-btn
        color="white"
        text
        @click="snackbarVerify = false"
      >
        Close
      </v-btn>
    </v-snackbar>
        <v-row justify-center align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
                <v-card flat class="px-2 mx-auto" id="login" max-width="500px">
                   
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <div class=" white--text text-center mr-2"  style="width:40%; border:3px #e0e0e0 solid">
                            <h3 class="text-center grey--text ma-0 pa-0">USD BALANCE</h3>
                            <p class="text-center green--text font-weight-bold ma-0 pa-0">{{parseFloat(wallet.walletBalanceUsd).toFixed(2)}}</p>
                        </div>
                        <div class=" white--text text-center mr-2"  style="width:40%; border:3px #e0e0e0 solid">
                            <h3 class="text-center grey--text ma-0 pa-0">BTC BALANCE</h3>
                            <p class="text-center green--text font-weight-bold ma-0 pa-0">{{parseFloat(wallet.walletBalanceBtc).toFixed(8)}}</p>
                        </div>
                        <v-spacer></v-spacer>
                        
                        
                    </v-card-actions>
                    <v-card-text class="text-center mt-12">
                        <v-btn small rounded text style="border:1px orange solid; width:50%" class="ma-2 text-none">
                            <v-icon class="orange--text">mdi-bitcoin</v-icon>
                            <span class="orange--text">BTC Wallet</span>
                        </v-btn>
                        <p class="green--text font-weight-bold">{{parseFloat(wallet.walletBalanceBtc).toFixed(8)}} BTC ({{parseFloat(wallet.walletBalanceUsd).toFixed(2)}} USD) AVAILABLE</p>
                        <p class="grey--text font-weight-bold">{{parseFloat(wallet.escrowWalletBtc).toFixed(8)}} BTC ({{parseFloat(wallet.escrowWalletUsd).toFixed(2)}} USD) IN ESCROW</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="orange" :loading="loading" class="font-weight-bold ma-2"  style="width:30%; border:1px blue solid">
                            WITHDRAW
                        </v-btn>
                        <v-btn text class="font-weight-bold ma-2" style="width:30%; border:1px blue solid" to="/wallet">
                            DEPOSIT
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>

                    <v-card-text class="text-center">
                        
                        <v-form>
                            <v-text-field class="mx-auto mb-n5" outlined v-model="amount" type="number" color="blue" dense style="width:70%" label="Amount in BTC" autofocus suffix="BTC"></v-text-field>
                            <!-- <span style="background-color:blue" class="mt-n12">BTC</span> -->
                            <span>WITHDRAW FEE 0.0001BTC</span>
                            <v-text-field class="mx-auto mt-4" outlined v-model="amount" type="text" color="blue" dense style="width:70%" label="BTC Adress"></v-text-field>
                        </v-form>
                        <v-btn dark color="blue" style="width:70%">WITHDRAW FUNDS</v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data(){
        return{
            snackbarVerify:false,
            text: 'Your account has not been verified! Check your mail for verification link',
            vertical: true,
        }
    },
    computed:{
        k(){
            return 0.0001
        },
        wallet(){
            return this.$store.state.auth.logindetails
        }
    },
    created(){
        const userLogged= this.$store.state.auth.isUserLogged
        const userVerified = this.$store.state.auth.logindetails.isVerified
        if(userLogged===true&&userVerified===0){
            this.snackbarVerify=true
        }
    }
}
</script>